exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.smooth-picker[data-v-6fa9c160] {\n  font-size: 32px;\n}\n@media (min-width: 0px) and (max-width: 764px) {\n.smooth-picker[data-v-6fa9c160] {\n    font-size: 5vw;\n}\n}\n", "", {"version":3,"sources":["/home/runner/work/online-store/online-store/src/components/common/BaseServicePickerMobile.vue"],"names":[],"mappings":";AAAA;EACE,gBAAgB;CAAE;AAEpB;AACE;IACE,eAAe;CAAE;CAAE","file":"BaseServicePickerMobile.vue","sourcesContent":[".smooth-picker {\n  font-size: 32px; }\n\n@media (min-width: 0px) and (max-width: 764px) {\n  .smooth-picker {\n    font-size: 5vw; } }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6fa9c160","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/BaseServicePickerMobile.vue
// module id = ZHNG
// module chunks = 18